import React from "react";
import appStoreImg from "../../../../images/app-store.svg";
import playStoreImg from "../../../../images/play-store.svg";

const IPHONE_APP_STORE_URL =
  "itms-apps://search.itunes.apple.com/WebObjects/MZSearch.woa/wa/search?media=software&term=best+nine";
const APP_STORE_URL = "https://itunes.apple.com/us/app/top-nine-for-instagram-2017/id1188477208?mt=8";

const StoreButtons = ({ className, style, onlyDeviceButton, isIphone }) => (
  <div className={"hero-buttons " + className} style={style}>
    {(!onlyDeviceButton || (onlyDeviceButton && isIphone)) && (
      <a
        className="btn btn-app-store"
        href={APP_STORE_URL}
        onClick={() => {
          if (window.gtag) {
            window.gtag("event", "onclick_app_store_button");
          }
        }}
      >
        <img style={{ width: "100%" }} src={appStoreImg} data-no-retina />
      </a>
    )}
    {(!onlyDeviceButton || (onlyDeviceButton && !isIphone)) && (
      <a
        className="btn btn-play-store"
        href="https://play.google.com/store/apps/details?id=com.bestnine&hl=en"
        onClick={() => {
          if (window.gtag) {
            window.gtag("event", "onclick_play_store_button");
          }
        }}
      >
        <img style={{ width: "100%" }} src={playStoreImg} data-no-retina />
      </a>
    )}
  </div>
);

export default StoreButtons;
